export enum GlobalTemplates {
  HACKATHON = 'hackathon',
  INCUBATOR = 'incubator',
  PITCH = 'pitch',
  POLL = 'poll',
  PRODUCTIMPROVEMENT = 'productimprovement',
  DISCUSS = 'discuss',
  EXPERTANALYSIS = 'expertanalysis'
}
